import { createRouter, createWebHashHistory } from 'vue-router'

import ChiRouter from './modules/Chi'
import ComplaintRouter from './modules/Complaint'
import CostRouter from './modules/Cost'
import CropInfoRouter from './modules/CropInfo'
import HeadmanRouter from './modules/Headman'
import LandRouter from './modules/Land'
import MemberRouter from './modules/Member'
import QuotaInfoRouter from './modules/QuotaInfo'
import RechargeRouter from './modules/Recharge'
import RechargeNotifyRouter from './modules/RechargeNotify'
import RefundRouter from './modules/Refund'
import RegionRouter from './modules/Region'
import ReleaseRouter from './modules/Release'
import LianReleaseRouter from './modules/LianRelease'
import TuanReleaseRouter from './modules/TuanRelease'
import OperateLogRouter from '@/router/modules/OperateLog'
import UserManageRouter from '@/router/modules/UserManage'
import RoleManageRouter from '@/router/modules/RoleManage'
import CompanyInfoRouter from '@/router/modules/CompanyInfo'
import CycleRouter from '@/router/modules/Cycle'
import AdminRouter from '@/router/modules/Admin'
import WaterPriceRouter from '@/router/modules/WaterPrice'
import RefundReportRouter from '@/router/modules/RefundReport'
import JieshuiRouter from '@/router/modules/Jieshui'
import LandlordRouter from '@/router/modules/Landlord'
import YuchongRouter from '@/router/modules/Yuchong'
// import TuanReleaseRouter from "@/router/modules/TuanRelease";
import DataDashboardRouter from '@/router/modules/Dashboard'
import RechargeDayRouter from './modules/RechargeDay'

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { // 路由元信息
      requiresAuth: true // 判断是否是内部页面  false为内部页面
    },
    component: () => import('@/views/Login/login.vue')
  },
  {
    path: '/forgetPass',
    name: 'ForgetPass',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/views/Login/forgetPass.vue')
  },
  {
    path: '/',
    name: 'Layout',
    // redirect: '/deviceManage',
    component: () => import(/* webpackChunkName: "index" */ '../layout/index.vue'),
    children: [
      {
        path: '/changePass',
        name: 'ChangePass',
        meta: {
          requiresAuth: false, // true表示需要登录
          leftMenu: false // false表示不需要左边菜单栏
        },
        component: () => import('@/views/Setting/changePass/index')
      },
      {
        path: 'perAccount',
        name: 'PerAccount',
        meta: {
          requiresAuth: false,
          leftMenu: false // false表示不需要左边菜单栏
        },
        component: () => import('@/views/PerAccount/index')
      }
    ]
  }
]

export const dynamicRoutes = [
  OperateLogRouter,
  UserManageRouter,
  RoleManageRouter,
  CompanyInfoRouter,
  ChiRouter,
  ComplaintRouter,
  CostRouter,
  CropInfoRouter,
  HeadmanRouter,
  LandRouter,
  MemberRouter,
  QuotaInfoRouter,
  RechargeRouter,
  RechargeNotifyRouter,
  RefundRouter,
  RegionRouter,
  ReleaseRouter,
  YuchongRouter,
  LianReleaseRouter,
  TuanReleaseRouter,
  LandlordRouter,
  CycleRouter,
  AdminRouter,
  WaterPriceRouter,
  RefundReportRouter,
  JieshuiRouter,
  DataDashboardRouter,
  RechargeDayRouter
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.addRoute(
  'Layout',
  { // 404页面
    path: '/:error*', // /:error -> 匹配 /, /one, /one/two, /one/two/three, 等
    name: '404',
    component: () => import('@/views/404.vue')
  }
)

export default router
